import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=6782772c&scoped=true&lang=pug&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=6782772c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6782772c",
  null
  
)

export default component.exports